/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host([disabled]) {
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--calcite-opacity-disabled);
}

:host([disabled]) *,
:host([disabled]) ::slotted(*) {
  pointer-events: none;
}

/**
* CSS Custom Properties
*
* These properties can be overridden using the component's tag as selector.
*
* @prop --calcite-chip-background-color: Specifies the component's background color.
* @prop --calcite-chip-border-color: Specifies the component's border color.
* @prop --calcite-chip-corner-radius: Specifies the component's corner radius.
* @prop --calcite-chip-text-color: Specifies the component's text color.
* @prop --calcite-chip-icon-color: Specifies the component's icon color.
* @prop --calcite-chip-close-icon-color: Specifies the component's close element icon color.
* @prop --calcite-chip-select-icon-color: Specifies the component's selection element icon color.
* @prop --calcite-chip-select-icon-color-pressed: Specifies the component's selection element icon color when active.
*
*/
:host {
  display: inline-flex;
  cursor: default;
  border-radius: var(--calcite-chip-corner-radius, 9999px);
}

/* Host Prop Variant styles */
:host([closed]) {
  display: none;
}

:host([appearance=outline]) .container,
:host([appearance=outline-fill]) .container {
  --calcite-internal-chip-close-icon-color: var(--calcite-color-text-3);
  color: var(--calcite-chip-text-color, var(--calcite-color-text-1));
}
:host([appearance=outline]):host([kind=brand]) .container,
:host([appearance=outline-fill]):host([kind=brand]) .container {
  border-color: var(--calcite-chip-border-color, var(--calcite-color-brand));
}
:host([appearance=outline]):host([kind=inverse]) .container,
:host([appearance=outline-fill]):host([kind=inverse]) .container {
  border-color: var(--calcite-chip-border-color, var(--calcite-color-border-inverse));
}
:host([appearance=outline]):host([kind=neutral]) .container,
:host([appearance=outline-fill]):host([kind=neutral]) .container {
  border-color: var(--calcite-chip-border-color, var(--calcite-color-border-1));
}

:host([appearance=outline]) .container {
  background-color: transparent;
}

:host([appearance=outline-fill]) .container {
  background-color: var(--calcite-chip-background-color, var(--calcite-color-foreground-1));
}

:host([appearance=solid]) .container {
  border-color: transparent;
}
:host([appearance=solid]):host([kind=brand]) .container, :host([appearance=solid]):host([kind=inverse]) .container {
  color: var(--calcite-chip-text-color, var(--calcite-color-text-inverse));
}
:host([appearance=solid]):host([kind=brand]) .close, :host([appearance=solid]):host([kind=inverse]) .close {
  outline-color: var(--calcite-color-text-inverse);
}
:host([appearance=solid]):host([kind=brand]) .container {
  background-color: var(--calcite-chip-background-color, var(--calcite-color-brand));
}
:host([appearance=solid]):host([kind=inverse]) .container {
  background-color: var(--calcite-chip-background-color, var(--calcite-color-inverse));
}
:host([appearance=solid]):host([kind=neutral]) .container {
  background-color: var(--calcite-chip-background-color, var(--calcite-color-foreground-2));
}

:host([kind=neutral]) .container {
  --calcite-internal-chip-close-icon-color: var(--calcite-color-text-3);
  color: var(--calcite-chip-text-color, var(--calcite-color-text-1));
}

:host([selected]) .select-icon {
  opacity: 1;
}

:host([scale=s]) .container {
  --calcite-internal-chip-block-size: 1.5rem /* 24px */;
  --calcite-internal-chip-container-space-x-end: 0.25rem /* 4px */;
  --calcite-internal-chip-container-space-x-start: 0.25rem /* 4px */;
  --calcite-internal-chip-font-size: var(--calcite-font-size--2);
  --calcite-internal-chip-icon-size: 1rem /* 16px */;
  --calcite-internal-chip-icon-space: 0.25rem /* 4px */;
  --calcite-internal-chip-image-size: 1.25rem /* 20px */;
  --calcite-internal-chip-title-space: 0.25rem /* 4px */;
  --calcite-internal-close-size: 1rem /* 16px */;
}
:host([scale=s]) .container:not(.closable).is-circle {
  --calcite-internal-chip-container-space-x-start: var(--calcite-spacing-px);
  --calcite-internal-chip-container-space-x-end: var(--calcite-spacing-px);
}
:host([scale=s]) .container.image--slotted:has(.chip-icon), :host([scale=s]) .container.image--slotted.text--slotted, :host([scale=s]) .container.image--slotted.closable {
  --calcite-internal-chip-image-space-x-end: 0.25rem /* 4px */;
}
:host([scale=s]) .container.image--slotted:not(.text--slotted, :has(.chip-icon)), :host([scale=s]) .container.image--slotted:not(.selectable) {
  --calcite-internal-chip-container-space-x-start: var(--calcite-spacing-px);
}
:host([scale=s]) .container.selectable.single:not(.is-circle).image--slotted {
  --calcite-internal-chip-container-space-x-start: var(--calcite-spacing-px);
}
:host([scale=s]) .container.selectable.single:not(.is-circle).selected {
  --calcite-internal-chip-select-space-x-end: 0.375rem /* 6px */;
  --calcite-internal-chip-select-space-x-start: 0;
}
:host([scale=s]) .container.selectable.single:not(.is-circle).selected.image--slotted {
  --calcite-internal-chip-select-space-x-end: 0.5rem /* 8px */;
  --calcite-internal-chip-select-space-x-start: 0.125rem /* 2px */;
}
:host([scale=s]) .container.multiple:not(.is-circle) {
  --calcite-internal-chip-container-space-x-start: 0.25rem /* 4px */;
  --calcite-internal-chip-select-space-x-end: 0.25rem /* 4px */;
  --calcite-internal-chip-select-space-x-start: 0.25rem /* 4px */;
}
:host([scale=s]) .container.multiple:not(.is-circle).image--slotted {
  --calcite-internal-chip-select-space-x-end: 0.5rem /* 8px */;
  --calcite-internal-chip-select-space-x-start: 0.375rem /* 6px */;
  --calcite-internal-chip-container-space-x-start: var(--calcite-spacing-px);
}
:host([scale=s]) .container.multiple:not(.is-circle).image--slotted:not(.text--slotted) {
  --calcite-internal-chip-select-space-x-start: 0.375rem /* 6px */;
}

:host([scale=m]) .container {
  --calcite-internal-chip-block-size: 2rem /* 32px */;
  --calcite-internal-chip-container-space-x-end: 0.375rem /* 6px */;
  --calcite-internal-chip-container-space-x-start: 0.375rem /* 6px */;
  --calcite-internal-chip-font-size: var(--calcite-font-size--1);
  --calcite-internal-chip-icon-size: 1.5rem /* 24px */;
  --calcite-internal-chip-icon-space: 0.375rem /* 6px */;
  --calcite-internal-chip-image-size: 1.5rem /* 24px */;
  --calcite-internal-chip-title-space: 0.375rem /* 6px */;
  --calcite-internal-close-size: 1.5rem /* 24px */;
}
:host([scale=m]) .container:not(.closable).is-circle {
  --calcite-internal-chip-container-space-x-end: var(--calcite-spacing-px);
  --calcite-internal-chip-container-space-x-start: var(--calcite-spacing-px);
}
:host([scale=m]) .container.image--slotted:not(.is-circle) {
  --calcite-internal-chip-container-space-x-start: 0.25rem /* 4px */;
}
:host([scale=m]) .container.image--slotted:has(.chip-icon), :host([scale=m]) .container.image--slotted.text--slotted, :host([scale=m]) .container.image--slotted.closable {
  --calcite-internal-chip-image-space-x-end: 0.375rem /* 6px */;
}
:host([scale=m]) .container.selectable.single:not(.is-circle).image--slotted {
  --calcite-internal-chip-container-space-x-start: 0.25rem /* 4px */;
}
:host([scale=m]) .container.selectable.single:not(.is-circle).selected {
  --calcite-internal-chip-select-space-x-end: var(--calcite-spacing-px);
  --calcite-internal-chip-select-space-x-start: 0;
}
:host([scale=m]) .container.selectable.single:not(.is-circle).selected.image--slotted {
  --calcite-internal-chip-select-space-x-end: 0.25rem /* 4px */;
  --calcite-internal-chip-select-space-x-start: 0.375rem /* 6px */;
}
:host([scale=m]) .container.multiple:not(.is-circle) {
  --calcite-internal-chip-select-space-x-end: 0.125rem /* 2px */;
  --calcite-internal-chip-select-space-x-start: 0.125rem /* 2px */;
}
:host([scale=m]) .container.multiple:not(.is-circle).image--slotted {
  --calcite-internal-chip-select-space-x-end: 0.5rem /* 8px */;
  --calcite-internal-chip-select-space-x-start: 0.25rem /* 4px */;
}
:host([scale=m]) .container.closable:not(.is-circle) {
  --calcite-internal-chip-container-space-x-end: 0.25rem /* 4px */;
}

:host([scale=l]) .container {
  --calcite-internal-chip-block-size: 2.75rem /* 44px */;
  --calcite-internal-chip-container-space-x-end: 0.5rem /* 8px */;
  --calcite-internal-chip-container-space-x-start: 0.5rem /* 8px */;
  --calcite-internal-chip-font-size: var(--calcite-font-size-0);
  --calcite-internal-chip-icon-size: 2rem /* 32px */;
  --calcite-internal-chip-icon-space: 0.5rem /* 8px */;
  --calcite-internal-chip-image-size: 2rem /* 32px */;
  --calcite-internal-chip-title-space: 0.5rem /* 8px */;
  --calcite-internal-close-size: 2rem /* 32px */;
}
:host([scale=l]) .container:not(.closable).is-circle {
  --calcite-internal-chip-container-space-x-end: 0.25rem /* 4px */;
  --calcite-internal-chip-container-space-x-start: 0.25rem /* 4px */;
}
:host([scale=l]) .container.image--slotted:not(.is-circle) {
  --calcite-internal-chip-container-space-x-start: 0.375rem /* 6px */;
}
:host([scale=l]) .container.image--slotted:has(.chip-icon), :host([scale=l]) .container.image--slotted.text--slotted, :host([scale=l]) .container.image--slotted.closable {
  --calcite-internal-chip-image-space-x-end: 0.5rem /* 8px */;
}
:host([scale=l]) .container.selectable.single:not(.is-circle).image--slotted {
  --calcite-internal-chip-container-space-x-start: 0.375rem /* 6px */;
}
:host([scale=l]) .container.selectable.single:not(.is-circle).selected {
  --calcite-internal-chip-select-space-x-end: 0.25rem /* 4px */;
  --calcite-internal-chip-select-space-x-start: 0;
}
:host([scale=l]) .container.selectable.single:not(.is-circle).selected.image--slotted {
  --calcite-internal-chip-select-space-x-end: 0.375rem /* 6px */;
  --calcite-internal-chip-select-space-x-start: 0.5rem /* 8px */;
}
:host([scale=l]) .container.multiple:not(.is-circle) {
  --calcite-internal-chip-container-space-x-start: 0.5rem /* 8px */;
  --calcite-internal-chip-select-space-x-end: 0.25rem /* 4px */;
  --calcite-internal-chip-select-space-x-start: 0.25rem /* 4px */;
}
:host([scale=l]) .container.multiple:not(.is-circle).image--slotted {
  --calcite-internal-chip-select-space-x-end: 0.75rem /* 12px */;
}
:host([scale=l]) .container.closable:not(.is-circle) {
  --calcite-internal-chip-container-space-x-end: 0.375rem /* 6px */;
}

.container {
  box-sizing: border-box;
  display: inline-flex;
  block-size: 100%;
  max-inline-size: 100%;
  align-items: center;
  justify-content: center;
  font-weight: var(--calcite-font-weight-medium);
  outline-color: transparent;
  border-radius: var(--calcite-chip-corner-radius, 9999px);
  border-width: var(--calcite-border-width-sm);
  border-style: solid;
  font-size: var(--calcite-internal-chip-font-size, var(--calcite-font-size));
  padding-inline-start: var(--calcite-internal-chip-container-space-x-start);
  padding-inline-end: var(--calcite-internal-chip-container-space-x-end);
  block-size: var(--calcite-internal-chip-block-size, auto);
  inline-size: var(--calcite-internal-chip-inline-size, auto);
  min-inline-size: var(--calcite-internal-chip-block-size, auto);
}
.container:hover .select-icon--active {
  opacity: 1;
}
.container.selectable {
  cursor: pointer;
}
.container:not(.non-interactive):focus {
  outline: 2px solid var(--calcite-ui-focus-color, var(--calcite-color-brand));
  outline-offset: calc(
            2px *
            calc(
              1 -
              2 * clamp(
                0,
                var(--calcite-offset-invert-focus),
                1
              )
            )
          );
}
.container.text--slotted .title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.container:not(.text--slotted) .title, .container:not(.image--slotted) .image-container {
  display: none;
}
.container.is-circle .chip-icon,
.container.is-circle .image-container {
  padding: 0;
}

.title {
  padding-inline: var(--calcite-internal-chip-title-space);
}

.image-container {
  display: inline-flex;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  block-size: var(--calcite-internal-chip-image-size, 1.5rem);
  inline-size: var(--calcite-internal-chip-image-size, 1.5rem);
  padding-inline-start: 0;
  padding-inline-end: var(--calcite-internal-chip-image-space-x-end, 0);
}

.chip-icon {
  position: relative;
  margin-block: 0px;
  display: inline-flex;
  transition-duration: 150ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  color: var(--calcite-chip-icon-color, var(--calcite-chip-text-color, var(--calcite-icon-color, currentColor)));
  padding-inline: var(--calcite-internal-chip-icon-space, 0.375rem);
}

.select-icon {
  align-self: center;
  justify-content: center;
  align-items: center;
  display: flex;
  inset-block-start: -1px;
  position: absolute;
  visibility: hidden;
  inline-size: auto;
  opacity: 0;
  transition: opacity 0.15s ease-in-out, inline-size 0.15s ease-in-out;
  color: var(--calcite-chip-select-icon-color, currentColor);
}
.select-icon.select-icon--active {
  position: relative;
  visibility: visible;
  opacity: 0.5;
  color: var(--calcite-chip-select-icon-color-pressed, var(--calcite-chip-select-icon-color, currentColor));
}

.multiple .select-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.multiple .select-icon,
.single .select-icon--active {
  padding-inline-start: var(--calcite-internal-chip-select-space-x-start);
  padding-inline-end: var(--calcite-internal-chip-select-space-x-end);
  block-size: var(--calcite-internal-chip-icon-size, 1.5rem);
  inline-size: var(--calcite-internal-chip-icon-size, 1.5rem);
}

slot[name=image]::slotted(*) {
  display: flex;
  block-size: 100%;
  inline-size: 100%;
  overflow: hidden;
  border-radius: 50%;
}

.close {
  margin: 0px;
  cursor: pointer;
  align-items: center;
  border-radius: 50%;
  border-style: none;
  outline-color: transparent;
  transition: background-color, block-size, border-color, box-shadow, color, inset-block-end, inset-block-start, inset-inline-end, inset-inline-start inset-size, opacity, outline-color, transform var(--calcite-animation-timing) ease-in-out 0s, outline 0s, outline-offset 0s;
  background-color: var(--calcite-close-background-color, var(--calcite-color-transparent));
  -webkit-appearance: none;
  display: flex;
  align-content: center;
  justify-content: center;
  color: var(--calcite-chip-close-icon-color, var(--calcite-close-icon-color, var(--calcite-internal-chip-close-icon-color, var(--calcite-color-text-1))));
  block-size: var(--calcite-internal-close-size, 1.5rem);
  inline-size: var(--calcite-internal-close-size, 1.5rem);
  padding: 0;
}
.close:hover, .close:focus {
  background-color: var(--calcite-close-background-color-hover, var(--calcite-color-transparent-hover));
}
.close:focus {
  outline: 2px solid var(--calcite-ui-focus-color, var(--calcite-color-brand));
  outline-offset: calc(
            -2px *
            calc(
              1 -
              2 * clamp(
                0,
                var(--calcite-offset-invert-focus),
                1
              )
            )
          );
}
.close:active {
  background-color: var(--calcite-close-background-color-press, var(--calcite-color-transparent-press));
}
.close calcite-icon {
  color: inherit;
}

:host([disabled]) ::slotted([calcite-hydrated][disabled]),
:host([disabled]) [calcite-hydrated][disabled] {
  /* prevent opacity stacking */
  opacity: 1;
}

.interaction-container {
  display: contents;
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}